import { Body, Card, Divider, H3, H6, Stack } from '@qred/components-library';
import React from 'react';
import { Timeline, TimelineStep } from '~/components/shared/Timeline/Timeline';
import { getMarketCurrency } from '~/helpers/formatters.helper';
import { useNumberFormatter } from '~/hooks/formatter/useNumberFormatter';
import useTranslate from '~/hooks/useTranslate';

const timelineSteps: TimelineStep[] = [
  {
    label: 'Onboarding.IndicativeOfferTimelineStep1',
    status: 'completed',
  },
  {
    label: 'Onboarding.IndicativeOfferTimelineStep2',
    status: 'current',
  },
  {
    label: 'Onboarding.IndicativeOfferTimelineStep3',
    status: 'upcoming',
  },
];

type IndicativeOfferProps = {
  minAmount: number;
  maxAmount: number;
};

export const IndicativeOffer = ({
  minAmount,
  maxAmount,
}: IndicativeOfferProps) => {
  const formatter = useNumberFormatter();
  const t = useTranslate();
  const currency = getMarketCurrency();

  const isKronaMarket = currency.unit === 'kr';
  const isEuroMarket = currency.unit === '€';
  const shouldShowPlusSign =
    (isKronaMarket && maxAmount === 500000) ||
    (isEuroMarket && maxAmount === 50000);

  return (
    <Stack spacing={'lg'}>
      <H6 data-record>{t('Onboarding.IndicativeOfferTitle')}</H6>
      <Stack spacing={'xl'}>
        <Stack spacing={'sm'}>
          <Body size="lg" data-record>
            {t('LoanAmount')}
          </Body>
          <H3 data-record>
            {formatter(minAmount)} - {formatter(maxAmount)} {currency.unit}
            {shouldShowPlusSign && '+'}
          </H3>
          <Divider color="Border/Minimal" />
        </Stack>
        <Card
          bg={'Container/Option_4_(Grey)'}
          px={'md'}
          py={'sm'}
          w={'100%'}
          style={{
            borderRadius: '8px',
          }}
        >
          <Stack align="center" spacing={'sm'}>
            <Body size="md" data-record>
              {t('Onboarding.IndicativeOfferTimelineTitle')}
            </Body>
            <Timeline steps={timelineSteps} />
          </Stack>
        </Card>
        <Body size="sm" align="center" data-record>
          {t('Onboarding.IndicativeOfferDisclaimer')}
        </Body>
      </Stack>
    </Stack>
  );
};
